module.exports = __webpack_public_path__ + "media/dashboard/assets/images/whatsapp-3efecbda2ef08e26cf55df759121b5c2.png";